import { useEffect, useState } from 'react';

const map = [
  { maxWidth: '800px', decks: 1 },
  { maxWidth: '1100px', decks: 2 },
  { maxWidth: '1550px', decks: 3 },
  { maxWidth: '2000px', decks: 4 },
  { maxWidth: '3000px', decks: 5 },
];

export function useTotalDecks(): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const updateCount = (): void => {
      const width = window.innerWidth;
      const matchedMap = map.find((item) => width <= parseInt(item.maxWidth));
      setCount(matchedMap ? matchedMap.decks : map[map.length - 1].decks);
    };

    window.addEventListener('resize', updateCount);
    updateCount();

    return () => {
      window.removeEventListener('resize', updateCount);
    };
  }, []);

  return count;
}
